import styled, { css } from 'styled-components/macro'

import { settings } from '../../styled/settings/index';
import { mixins } from '../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { heading1, heading2, heading3, heroDescription },
} = mixins;

export const LandingPageContainer = styled.section`
  ${pageSection}
  background-color: ${color(`white`)};
`;

export const LandingPageInnerContainer = styled.div`
  ${pageSectionInner}
`;

export const SignatureContainer = styled.div`
  ${pageSectionInner}
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Signature = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: ${spacingsize(7)};

  div {
    display: flex;
    align-items: center;
  }
`;

export const SignatureImage = styled.img`
  justify-content: flex-end;
  border-radius: 50%;
  height: 125px;
  width: 125px;
  display: inline-block;

  @media ${mobileDown} {
    width: 75px;
    height: 75px;
  }
`;